/**
 * List of options for the Operation field of resource types that support Production Workflows
 *
 * @namespace tmrProductionWorkflowOperations
 * @type {ngConstant}
 */
export const constant = [
  'tmrProductionWorkflowOperations',
  {
    transferToZone: 'PRODUCTIONWORKFLOWOPERATIONS.TRANSFERTOZONE',
  },
]

/**
 * Translates {@link tmrProductionWorkflowOperations}
 *
 * @type {ngRun}
 */
let tmrProductionWorkflowOperationsRun = /*@ngInject*/ (
  TmrTranslate,
  tmrProductionWorkflowOperations
) => TmrTranslate.object(tmrProductionWorkflowOperations)

export { tmrProductionWorkflowOperationsRun as run }
